import React from 'react';
import VoiceToTextTextarea from '@components/VoiceToTextTextarea';
import { AboutMeTypes } from '../StepThreeTypes';
import getVoiceToTextBlockedMessages from './VoiceTranscribing/utils';
import '../styles.scss';

interface MostImportantToMeProps {
  aboutMe: AboutMeTypes;
  setAboutMe: (aboutMe: AboutMeTypes) => void;
}

const MostImportantToMe: React.FC<MostImportantToMeProps> = ({
  aboutMe,
  setAboutMe,
}) => {
  return (
    <div>
      <div className="govuk-form-group mt-10 govuk-bp:mt-14">
        <h1 className="govuk-label-wrapper">
          <label
            className="govuk-label govuk-label--l"
            htmlFor="most-important-to-me"
          >
            What is most important to me
          </label>
        </h1>
        <div className="govuk-body">
          A description of what is most important to you
        </div>

        <div className="govuk-body">
          <h3 className="govuk-heading-s key-information">Key Information:</h3>
          <div className="govuk-body inline">
            {' '}
            Include any essential information that any professional in health
            and social care should know about you in any situation, including
            emergencies.
          </div>
        </div>
        <div className="govuk-body">
          <h3 className="govuk-heading-s other-information">
            Other Information:
          </h3>
          <div className="govuk-body inline">
            {' '}
            This could include: Values, Spirituality/religion, Ethnicity,
            Culture, Pets, Goals and aspirations, Meaningful activities
            including leisure activities, visiting places, sport and exercise,
            listening to music, employment, education, volunteering.
          </div>
        </div>
        <details className="govuk-details">
          <summary className="govuk-details__summary">
            <span className="govuk-details__summary-text">
              Prompt questions
            </span>
          </summary>
          <div className="govuk-details__text">
            <div className="govuk-body">
              We need to know your nationality so we can work out which
              elections you’re entitled to vote in. If you cannot provide your
              nationality, you’ll have to send copies of identity documents
              through the post.
            </div>

            <h3 className="govuk-heading-s">
              1. What does someone caring for, or supporting you, need to know
              about you in an emergency?
            </h3>
            <div className="govuk-body">
              Consider including any important preferences, needs and wishes
              that indicate how you need to be cared for and supported in an
              emergency such as the need to avoid any disturbing stimuli e.g.,
              noise, visual, smell, taste or touch etc. for example by being
              seen in a quiet or darkened room, the need for visual aids, the
              need for a translator or the need for vegan appropriate
              medications etc.
            </div>
            <div className="govuk-body">
              Consider including any food allergies or risk of choking. Consider
              referencing other documents in which you have already recorded any
              needs, wishes and preferences such as an advance decision, a
              lasting power of attorney, a communication or hospital passport or
              an end-of-life plan.
            </div>

            <h3 className="govuk-heading-s">
              2. What’s most important to you?
            </h3>
            <div className="govuk-body">
              This is just as important as emergency information. Think about
              your core values, spiritual beliefs, culture, ethnicity and
              religion as they relate to your care. Think about what makes you
              happy, for example meaningful activities you enjoy, pets, objects,
              computer games, exercise sport, places you like to visit,
              education or spending time with family and friends. There may be a
              specific stimulating sensory item or activity you enjoy.
            </div>

            <h3 className="govuk-heading-s">
              3. What are your aspirations and goals for the future?
            </h3>
          </div>
        </details>
        <VoiceToTextTextarea
          id="most-important-to-me"
          name="mostImportantToMe"
          value={aboutMe.mostImportantToMe || ''}
          rows={5}
          autoComplete="bio"
          placeholder="Type here or use voice to text..."
          recordBlockedErrors={getVoiceToTextBlockedMessages(aboutMe)}
          onChange={value =>
            setAboutMe({
              ...aboutMe,
              mostImportantToMe: value,
            })
          }
        />
      </div>
    </div>
  );
};

export default MostImportantToMe;
